export default __webpack_public_path__ + "static/media/mapFrameRectangleLandranger.494a2380.jpg";